import { ASSOCIATED_TOKEN_PROGRAM_ID, Token, TOKEN_PROGRAM_ID } from '@solana/spl-token';
import {
    PublicKey,
    TransactionInstruction,
    Transaction,
    SystemProgram,
} from '@solana/web3.js';
import { wrappedSOL } from '../../config/tokenRegistry';
import { DraffleProgram } from '../../providers/ProgramApisProvider';
import { Raffle } from '../types';
//@ts-ignore
const ADMIN = new PublicKey("Cfr5NgKCk2Fawmxc7pfJiy2BJpTzNw8z5FVoXvXaBH7H");
export const collectProceeds = async (
    draffleClient: DraffleProgram,
    creator: PublicKey,
    proceedsMint: PublicKey,
    raffle: Raffle
) => {


    // Begin transaction instructions
    let instructions: TransactionInstruction[] = [];

    // Get creator proceed account
    //initialize this if not initialized: TODO
    const creatorProceeds = await Token.getAssociatedTokenAddress(
        ASSOCIATED_TOKEN_PROGRAM_ID,
        TOKEN_PROGRAM_ID,
        raffle.proceeds.mint.publicKey,
        draffleClient.provider.wallet.publicKey,
    );

    // console.log(creatorProceeds.toBase58(), 'creator-proceeds-account')
    const creatorTokenData = await draffleClient.provider.connection.getParsedAccountInfo(
        creatorProceeds
    )
    // console.log(creatorTokenData, 'ctd')

    if (!creatorTokenData?.value) {
        // console.log('Creator Token Account Not Initialized')
        // console.log( raffle.proceeds.mint.publicKey.toBase58(), 'proceredsMint')
        instructions.push(
            Token.createAssociatedTokenAccountInstruction(
                ASSOCIATED_TOKEN_PROGRAM_ID,
                TOKEN_PROGRAM_ID,
                new PublicKey(raffle.proceeds.mint.publicKey),
                creatorProceeds,
                draffleClient.provider.wallet.publicKey,
                draffleClient.provider.wallet.publicKey
            )
        );
        // instructions.push(
        //     SystemProgram.transfer({
        //         fromPubkey: draffleClient.provider.wallet.publicKey,
        //         toPubkey: creatorProceeds,
        //         lamports: await Token.getMinBalanceRentForExemptAccount(draffleClient.provider.connection),
        //     })
        // )
    }

    const adminProceeds = await Token.getAssociatedTokenAddress(
        ASSOCIATED_TOKEN_PROGRAM_ID,
        TOKEN_PROGRAM_ID,
        raffle.proceeds.mint.publicKey,
        ADMIN,
    );
    // console.log(adminProceeds.toBase58(), 'admin token account')
    const adminTokenData = await draffleClient.provider.connection.getParsedAccountInfo(
        adminProceeds
    )
    // console.log(adminTokenData, 'atd')

    if (!adminTokenData?.value) {
        // console.log('Admin Token Account Not Initialized')
        // console.log(raffle.proceeds.mint.publicKey.toBase58(), 'proceredsMint')
        instructions.push(
            Token.createAssociatedTokenAccountInstruction(
                ASSOCIATED_TOKEN_PROGRAM_ID,
                TOKEN_PROGRAM_ID,
                new PublicKey(raffle.proceeds.mint.publicKey),
                adminProceeds,
                ADMIN,
                draffleClient.provider.wallet.publicKey
            )
        );
        // instructions.push(
        //     SystemProgram.transfer({
        //         fromPubkey: draffleClient.provider.wallet.publicKey,
        //         toPubkey: creatorProceeds,
        //         lamports: await Token.getMinBalanceRentForExemptAccount(draffleClient.provider.connection),
        //     })
        // )
    }



    // Create raffle
    instructions.push(
        draffleClient.instruction.collectProceeds({
            accounts: {
                raffle: raffle.publicKey,
                proceeds: proceedsMint,
                creator: creator,
                creatorProceeds: creatorProceeds,
                admin: ADMIN,
                adminTokenAccount: adminProceeds,
                entrants: raffle.entrantsAccountAddress,
                tokenProgram: TOKEN_PROGRAM_ID,
            },
        })
    );

    console.log(
        `You have successfully collected your proceeds`
    );

    // Sign with entrants keypair
    return draffleClient.provider.sendAndConfirm(
        new Transaction().add(...instructions),
        []
    );
};